import { render } from "./onePostShow.vue?vue&type=template&id=1e114f9f&scoped=true"
import script from "./onePostShow.vue?vue&type=script&lang=js"
export * from "./onePostShow.vue?vue&type=script&lang=js"

import "./onePostShow.vue?vue&type=style&index=0&id=1e114f9f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e114f9f"

export default script